import React, { Fragment, useState, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Renderer, marked } from 'marked';
import { useReactTable } from '@tanstack/react-table';
import { skills, tabulateSkills } from '../../resources/skills';

// Wiki Sections
import { wikiSections, introSubSections, charCreationSubSections, charStatsSubSections, skillSubSections, equipSubSections, outsideCombatSubSections, combatSubSections, kaleidoSubSections, appendixSubSections } from '../../resources/arrays';

// Actions
import { getWikiPages } from '../../actions/wiki';

// Components
import WikiPerkTable from './WikiPerkTable';


const wikiPageList = [].concat.apply([], [introSubSections, charCreationSubSections, charStatsSubSections, skillSubSections, equipSubSections, outsideCombatSubSections, combatSubSections, kaleidoSubSections, appendixSubSections ])

// TO DO
// - Wiki search option?

const WikiHome = ({
    getWikiPages,
    wiki,
    auth: {user}
}) => {

    useEffect(() => {
        if(wiki.loading || wiki.wikiPages.length === 0){
            getWikiPages();
        }
    }, [wiki.loading, getWikiPages]);

    const imgFolder = '/static/media/';

    const [ curWikiPage, updateCurWikiPage] = useState("Introduction");
    const [ curWikiInd, updateCurWikiInd] = useState(0);

    useLayoutEffect(() => {
        document.title = curWikiPage + ' - KRPG Wiki';
       }, []);

    const perkArray = tabulateSkills();

    const perkTable = useReactTable(perkArray);

    const updateCurWiki = (subSec) => e => {
        updateCurWikiPage(subSec);
        updateCurWikiInd(wikiPageList.findIndex(w => w === subSec))

        document.title = subSec + ' - KRPG Wiki'

        window.scrollTo(0,0);
    }

    marked.use({Renderer: true});

    const rawMarkup = entry => {
        let rawMarkup = marked(entry, {baseUrl: imgFolder});
        return { __html: rawMarkup };
    }

    const showCurWiki = () => {

        if(!wiki.loading){
            var curWiki = wiki.wikiPages.find(w => w.subSection === curWikiPage);

            if(curWiki !== undefined){
                var curWikiHTML = rawMarkup(curWiki.markdown);

                return curWikiHTML;
            } else {
                return (rawMarkup("# Sorry, that page doesn't exist yet!"));
            }
        }
    }

    const prevPage = () => {

        var curInd = wikiPageList.findIndex(w => w === curWikiPage);

        var prevWiki = wikiPageList[curInd - 1];
        
        if(prevWiki !== undefined){
            return prevWiki
        } else {
            return;
        }
    }

    const nextPage = () => {

        var curInd = wikiPageList.findIndex(w => w === curWikiPage);
        
        var nextWiki = wikiPageList[curInd + 1];
        
        if(nextWiki !== undefined){
            return nextWiki;
        } else {
            return;
        }
    }

    console.log(curWikiPage)

    return (
        <Fragment>
            <div className="wikiHomeContainer">
                <div className="wikiMenu">
                    {wikiSections.map((sec, index) =>
                        <div key={index} className="sectionMenu">
                            <div>{wikiSections[index]}</div>
                            <div className="subSectionMenu">
                            {
                                index === 0 ? introSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 1 ? charCreationSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 2 ? charStatsSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 3 ? skillSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 4 ? equipSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 5 ? outsideCombatSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 6 ? combatSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 7 ? kaleidoSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                index === 8 ? appendixSubSections.map((s, index) => <div key={index} onClick={e => updateCurWiki(s)(e)}>{s}</div>) :
                                <div></div>
                            }
                            </div>
                        </div>
                    )}
                    <Link to="/wiki/create-new-page" className={user.isAdmin ? "wikiEdit" : "hidden"}>Wiki Editor</Link>
                </div>
                <div className="wikiPageViewer">
                    {
                        curWikiPage === "Perks" ?
                        <WikiPerkTable /> :
                        <div dangerouslySetInnerHTML={showCurWiki()}></div>
                    }
                    <div className="wikiFooterNav">
                        <div className="wikiFooterContainer">
                            {curWikiInd > 0 && <div className="wikiFooterButtonLeft" onClick={e => updateCurWiki(wikiPageList[curWikiInd - 1])(e)}>{wikiPageList[curWikiInd - 1]}</div>}
                        </div>
                        <div className="wikiFooterContainer">
                            <div className="wikiFooterButtonRight" onClick={e => updateCurWiki(wikiPageList[curWikiInd + 1])(e)}>{wikiPageList[curWikiInd + 1]}</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </Fragment>
    )
}

WikiHome.propTypes = {
    getWikiPages: PropTypes.func.isRequired,
    wiki: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    wiki: state.wiki,
    auth: state.auth
});

export default connect(mapStateToProps, { getWikiPages })(WikiHome);